// Periodic check-ins: every 1, 3 or 6 months (or never). One quiet card when due; dismissing it
// snoozes until the next interval. It never asks for anything the app already knows.

import type { CheckIn } from '../state/schema';
import { addDays } from '../lib/dates';

export function addMonths(iso: string, months: number): string {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  const date = new Date(y, m - 1 + months, d);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export interface CheckInState {
  intervalMonths: 0 | 1 | 3 | 6;
  /** When the user finished onboarding, or the oldest cooked date if unknown. */
  startedAt: string | null;
  history: CheckIn[];
  snoozedUntil: string | null;
}

export function nextCheckInDate(s: CheckInState): string | null {
  if (!s.intervalMonths || !s.startedAt) return null;
  const last = s.history.length ? s.history[0].at : s.startedAt;
  return addMonths(last.slice(0, 10), s.intervalMonths);
}

export function checkInDue(s: CheckInState, today: string): boolean {
  const next = nextCheckInDate(s);
  if (!next || next > today) return false;
  return !s.snoozedUntil || s.snoozedUntil <= today;
}

/** Dismissing waits a full interval (minimum two weeks) before asking again. */
export function snoozeUntil(s: CheckInState, today: string): string {
  return s.intervalMonths ? addMonths(today, s.intervalMonths) : addDays(today, 14);
}
